import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const inputCls = "mt-2 w-full rounded-xl border border-[#2E2A24] bg-[#0A0A0C] px-4 py-3 text-[#F5EFE6] outline-none transition-[border-color] focus:border-[#C4832B]";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0A0A0C] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-[28px] border border-[#2E2A24] bg-[#121215] p-8" data-testid="admin-login-form">
        <img src="/brand/rco-white.webp" alt="The Rhett Co" className="w-16" />
        <h1 className="mt-6 font-display text-4xl text-[#F5EFE6]">Admin</h1>
        <p className="mt-1 text-sm text-zinc-400">Sign in to manage The Rhett Co site.</p>
        <label className="mt-8 block text-sm text-zinc-300">
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email-input" />
        </label>
        <label className="mt-5 block text-sm text-zinc-300">
          Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password-input" />
        </label>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-[#C4832B] py-3 font-medium text-[#0A0A0C] transition-[background-color] hover:bg-[#E09838] disabled:opacity-60" data-testid="admin-login-submit">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
